import { FlexContainer } from '../../../../../common/flex-container/flex-container.styles';
import {
  ShipmentStatus,
  TrackingItem,
} from '../../../../../models/parcelDeliveryMiles';
import { formatUtcDateTime } from '../../../../../utils/generic/generic.utils';
import { ParcelHistoryProgress } from './parcel-history.helpers';
import {
  TrackingDetailsDate,
  TrackingDetailsDesc,
} from './parcel-history.styles';

interface Props {
  trackingItem: TrackingItem;
  progress: ParcelHistoryProgress;
  status: ShipmentStatus;
}

const ParcelTrackingItem = ({ trackingItem, progress, status }: Props) => (
  <FlexContainer
    $mb='4px'
    $align='top'
    $gap='1.2rem'>
    <TrackingDetailsDesc $colorType={progress}>
      {trackingItem.text}
    </TrackingDetailsDesc>
    <TrackingDetailsDate $colorType={progress}>
      {status !== 'ready_to_pick_up'
        ? formatUtcDateTime(trackingItem.created_at, true, ', ')
        : trackingItem.created_at}
    </TrackingDetailsDate>
  </FlexContainer>
);

export default ParcelTrackingItem;
